import axiosClient, { app_uri } from "../../../utils/axiosFactory";
import { CommonClient } from "../../repsaApi";

const client = new CommonClient(app_uri, axiosClient());

const coAgentFilterApi = {
  async getCoAgentFilter(): Promise<number[]> {
    return await client.getCoAgentFilter();
  },
  async saveCoAgentFilter(coAgentIds: number[]): Promise<void> {
    return await client.saveCoAgentFilter(coAgentIds);
  },
};

export default coAgentFilterApi;
